import { render, staticRenderFns } from "./ItemUnavailableDialog.vue?vue&type=template&id=0254eb28&"
import script from "./ItemUnavailableDialog.vue?vue&type=script&lang=js&"
export * from "./ItemUnavailableDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports